module.exports = __webpack_public_path__ + "media/images/help/about/eyecatch-reason-2-9782cda7d5a1e1c9e3402f302abae0e4.jpg";